import {URL_API} from "../../../url.config";
import {request} from "../../../utils/apiUtils";
let NotiController = {
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/detail/?id=${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    addYear: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/add-year/${payload.yearId}?schoolId=${payload.schoolId}`,
            method: 'GET'
        }, callback)
    }
}
export default NotiController
